<template>
    <v-dialog v-model="internalDialog" flat max-width="460" class="lucky-card-dialog">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>

        <v-row no-gutters>
            <v-spacer />
            <v-col cols="auto">
                <v-btn small icon class="transparent" @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <!-- <v-img src="/images/event/clover/lucky-card-dialog--1.jpg" class="lucky-card-dialog__image" alt="1등 A클로버를 뽑았다!"> -->
            <!-- <v-img src="/images/event/clover/lucky-card-dialog--2.jpg" class="lucky-card-dialog__image" alt="1등 A클로버를 뽑았다!"> -->
            <!-- <v-img src="/images/event/clover/lucky-card-dialog--3.jpg" class="lucky-card-dialog__image" alt="2등 클로버2 카드를 뽑았다!"> -->
            <!-- <v-img src="/images/event/clover/lucky-card-dialog--4.jpg" class="lucky-card-dialog__image" alt="3등 클로버3 카드를 뽑았다!"> -->
            <!-- <v-img src="/images/event/clover/lucky-card-dialog--5.jpg" class="lucky-card-dialog__image" alt="5등 클로버5 카드를 뽑았다!"> -->
            <!-- <v-img src="/images/event/clover/lucky-card-dialog--all.jpg" class="lucky-card-dialog__image" alt="클로버6 카드를 뽑았다!"> -->
            <v-img src="/images/event/clover/lucky-card-dialog--duplicate.jpg" class="lucky-card-dialog__image" alt="클로버6 카드를 뽑았다!">
            <v-responsive :aspect-ratio="460 / 610">
                <!-- 중복참여시 노출 X -->
                <div>
                    <div class="dialog-spacer" />
                    <router-link to="/mypage/event" target="_blank" class="dialog-button">
                        <v-img src="/images/event/clover/dialog-button.svg" alt="이벤트 참여내역" />
                    </router-link>
                    <v-container>
                        <p class="page-text page-text--small text-center mt-14px">
                            나누리 캐시는 자동지급되며 <br />
                            마이페이지 - 내 캐시내역에서 받기 후 사용하실 수 있습니다.
                        </p>
                    </v-container>
                </div>
            </v-responsive>
        </v-img>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            internalDialog: this.value,
        };
    },
    watch: {
        value(val) {
            this.internalDialog = val;
        },
        internalDialog(val) {
            this.$emit("input", val);
        },
    },
    methods: {
        closeDialog() {
            this.internalDialog = false;
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-dialog {
        box-shadow: none;
    }
}
.dialog-spacer {
    aspect-ratio: 460 / 450;
}
.dialog-button {
    display: block;
    max-width: calc(160 / 460 * 100%);
    margin: 0 auto;
}
.lucky-card-dialog {
    &__image {
        border-radius: 20px;
    }
}
</style>